require('./RAEmailForm.scss');

const PropTypes = require('prop-types');
// @vendor
const React = require('react');

//@commons
const { formatText } = require('core/i18n').i18n;
const { InputSafe } = require('commonsComponents/inputSafe');

// @ helpers
const PersonalDataHelper = require('utilities/personalDataHelper');

class EditEmailForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        const { name, value } = event.target;
        const { actionChangeValue, immStep } = this.props;
        const repeatEmail = immStep.get('repeatEmail');
        const newProps = {
            [name]: value,
            [`${name}Dirty`]: !!value,
            emailBlur: false,
            repeatEmailBlur: false,
        };

        if (name === 'email' && repeatEmail) {
            newProps.repeatEmail = '';
        }
        actionChangeValue(newProps);
    }

    render() {
        const {
            getValidation,
            handleBlur,
            immProfileFields,
            immStep,
        } = this.props;

        const email = immStep.get('email');
        const emailBlur = immStep.get('emailBlur');
        const emailIsValid =
            PersonalDataHelper.isValidEmail(email) &&
            PersonalDataHelper.getEmail(immProfileFields).toLowerCase() !==
                email.toLowerCase();
        const { emailErrorState, emailErrorMsg } = getValidation(
            'email',
            email,
            emailBlur,
            emailIsValid,
        );
        const emailLabel = formatText('raEmail-raEmail_EmailLabel');
        const confirmEmailLabel = formatText(
            'raEmail-raEmail_ConfirmEmailLabel',
        );
        const emailErrorMessage = formatText(`profile-${emailErrorMsg}Email`);
        const repeatEmail = immStep.get('repeatEmail');
        const repeatEmailBlur = immStep.get('repeatEmailBlur');
        const repeatEmailIsValid = email === repeatEmail;
        const { repeatEmailErrorState, repeatEmailErrorMsg } = getValidation(
            'repeatEmail',
            repeatEmail,
            repeatEmailBlur,
            repeatEmailIsValid,
        );
        const repeatEmailErrorMessage = formatText(
            `profile-${repeatEmailErrorMsg}RepeatEmail`,
        );

        return (
            <div>
                <div className="row ra-email-form__form-section--with-margin-bottom">
                    <div className="col-xs-6 ra-email-form__min-height-field">
                        <InputSafe
                            label={emailLabel}
                            name="email"
                            onBlur={handleBlur}
                            onChange={this.handleInputChange}
                            type="text"
                            value={email}
                            errorState={emailErrorState}
                            errorMessage={emailErrorMessage}
                        />
                    </div>
                    <div className="col-xs-6 ra-email-form__min-height-field">
                        <InputSafe
                            label={confirmEmailLabel}
                            name="repeatEmail"
                            onBlur={handleBlur}
                            onChange={this.handleInputChange}
                            type="text"
                            value={repeatEmail}
                            errorState={repeatEmailErrorState}
                            errorMessage={repeatEmailErrorMessage}
                            disabled={!emailIsValid}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

EditEmailForm.propTypes = {
    actionChangeValue: PropTypes.func.isRequired,
    getValidation: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
    immProfileEditor: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immStep: PropTypes.object.isRequired,
};

module.exports = EditEmailForm;
